import { AutogenModelUserHomePage, AutogenRowUserHomePage } from "./autogen/AutogenModelUserHomePage";

export class ModelUserHomePage extends AutogenModelUserHomePage<RowUserHomePage> {
	constructor() {
		super(RowUserHomePage);
	}
}

export class RowUserHomePage extends AutogenRowUserHomePage {
}